import { LogManager } from 'core/logging/LogManager';
import { httpClient } from 'core/net/http';
import * as v from 'valibot';

const logger = LogManager.getLogger('fetchScenarioAlias', { error: { logToServer: true } });

export async function fetchScenarioAlias(scenarioName: string) {
  const response = await httpClient.useInternalApi
    .asAuthorised()
    .get('/configuration/blasting/scenarios/valid-alias', { alias: scenarioName });

  if (!response.isSuccess) {
    const errorMessage = `Failed to fetch scenario alias for scenaraio name "${scenarioName}"`;
    logger.error(errorMessage);
    throw new Error(errorMessage);
  }

  const parsedResponseData = v.safeParse(v.string(), response.data);

  if (!parsedResponseData.success) {
    const errorMessage = `Failed to parse scenario alias response for scenaraio name "${scenarioName}"`;
    logger.error(errorMessage, parsedResponseData.issues);
    throw new Error(errorMessage);
  }

  return parsedResponseData.output;
}
